module.exports = __webpack_public_path__ + "img/i_main_my_internet.71633ee3.svg";